import { memo, type ReactNode, useMemo, useState } from 'react'

import { defaultLanguage, type Language } from '@orus.eu/translations'

import { getDefaultLanguageFromUrl } from './default-language-from-url.ts'
import { DefaultLanguageProvider } from './language-context.ts'

export const DefaultLanguageProviderWrapper = memo<{ children: ReactNode }>(function DefaultLanguageProviderWrapper({
  children,
}) {
  const [language, setLanguage] = useState<Language>(getDefaultLanguageFromUrl() ?? defaultLanguage)

  const languageContextValue = useMemo(() => ({ language, setLanguage }), [language, setLanguage])

  return <DefaultLanguageProvider value={languageContextValue}>{children}</DefaultLanguageProvider>
})
